export default "__VITE_ASSET__95e6144c__"